<template>
<div class="container">
  <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
  >
    <el-table-column property="id" label="ID" align="center" width="50"></el-table-column>
    <el-table-column property="name" label="联系人" align="center" width="150"></el-table-column>
    <el-table-column property="mobile" label="手机号" width="130" align="center"></el-table-column>
    <el-table-column property="city" label="城市" align="center" width="120"></el-table-column>
    <el-table-column property="advise" label="建议" align="center" show-overflow-tooltip ></el-table-column>
    <el-table-column property="c_at" label="添加时间" width="170"  :formatter="dateFormatHMS"></el-table-column>
  </el-table>
  <div class="pagination">
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="query.page"
        :page-sizes="[10,20, 50, 100, 200]"
        :page-size="10"
        layout="total,sizes, prev, pager, next"
        :total="pageTotal">
    </el-pagination>
  </div>
</div>
</template>

<script>
import {getUserJoinApplys} from "@/api/user";
import moment from "moment";

export default {
  name: "JoinApply",
  data(){
    return{
      tableData:[],
      query:{
        page:1,
        page_size:10
      },
      pageTotal:0
    }
  },
  created(){
    this.getData()
  },
  methods:{
    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    getData(){
      getUserJoinApplys(this.query).then(res=>{
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    handleSearch(){
      this.query.page = 1
      this.getData()
    },
    // 每页大小变化
    handleSizeChange(val){
      this.query.page_size = val
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
  }
}
</script>

<style scoped>

</style>